import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, title }) => (
  <div className="flex items-center gap-4 mb-10">
    <span className="text-xs text-[#C5A880] font-semibold">
      {index}
    </span>
    <span className="h-px w-12 bg-[#C5A880]/60" />
    <span className="text-sm text-[#6E6760]st">{title}</span>
  </div>
);
